import { STDocument } from '@st/sdk'
import { Button, Dialog, DialogButtons, TextInput } from '@st/theme'
import { extname, isValidFilename, rootname } from '@st/util/file'
import { useState } from 'react'
import { ErrorMessage } from '@components/error-message'
import { useProcess } from '~/store'

export function STRenameDocumentDialog({
  folderId,
  doc,
  onClose
}: {
  folderId: string
  doc: STDocument
  onClose: () => void
}) {
  const stFolder = useProcess('stFolder')

  const docRootName = rootname(doc.name)
  const [newDocumentName, setNewDocumentName] = useState(docRootName)
  const invalidName = !isValidFilename(newDocumentName + extname(doc.name))

  return (
    <Dialog
      title="Rename document"
      subtitle={`Enter a new name for ${doc.name}`}
      buttons={
        <DialogButtons>
          <Button variant="default" onClick={onClose}>
            Close
          </Button>
          <Button
            variant="primary"
            disabled={
              newDocumentName == docRootName || newDocumentName.length == 0 || invalidName
            }
            onClick={() => {
              const newDocNameWithExtension = newDocumentName + extname(doc.name)
              stFolder.send({
                type: 'renameDocument',
                folderId: folderId,
                documentId: doc.id,
                oldDocumentName: doc.name,
                newDocumentName: newDocNameWithExtension
              })
              onClose?.()
            }}
          >
            Rename
          </Button>
        </DialogButtons>
      }
    >
      <TextInput
        className="w-full"
        autoFocus={true}
        value={newDocumentName}
        onChange={setNewDocumentName}
      />
      {invalidName && <ErrorMessage message={'Document names cannot contain "/" or "\\".'} />}
    </Dialog>
  )
}
